import {
  ShieldOff,
  Clock4,
  PiggyBank,
  Banknote,
  HeartHandshake,
} from "lucide-react";

const USPS = [
  {
    icon: PiggyBank,
    title: "ROI 6.5% – 15%",
    desc: "Industry-leading rates across loan products.",
  },
  {
    icon: ShieldOff,
    title: "No CIBIL Required",
    desc: "Credit-history-free approvals for first-time borrowers.",
  },
  {
    icon: Clock4,
    title: "24–72h Approval",
    desc: "Quick disbursal with minimal documentation.",
  },
  {
    icon: Banknote,
    title: "Up to 100% Funding",
    desc: "On-asset financing — vehicles, machinery, housing.",
  },
  {
    icon: HeartHandshake,
    title: "Pan-India Service",
    desc: "Doorstep service backed by Vyara, Gujarat HQ.",
  },
  // LR-005: "Acuité BB Rated" tile hidden pending a current verified rating letter
];

export default function USPStrip() {
  return (
    <section
      data-testid="usp-strip"
      className="relative bg-[#04102B] border-y border-[#D4AF37]/15 py-10 md:py-14"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {USPS.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              data-testid={`usp-${title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
              className="group text-center md:text-left flex md:flex-col items-center md:items-start gap-3 md:gap-4"
            >
              <span className="w-11 h-11 shrink-0 rounded-lg grid place-items-center bg-[#D4AF37]/12 text-[#F0D788] border border-[#D4AF37]/30 group-hover:bg-[#D4AF37]/25 transition">
                <Icon size={20} strokeWidth={1.75} />
              </span>
              <div>
                <div className="font-display text-white text-base md:text-lg leading-tight">
                  {title}
                </div>
                <div className="text-white/55 text-[12px] md:text-[13px] mt-1 leading-snug">
                  {desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
